import styles from "./DashboardLayout.module.css";
import TopBar from "../../sections/TopBar/TopBar";
import SideBar from "../../sections/SideBar/SideBar";
import { Outlet } from "react-router";
import { useState } from "react";

function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className={styles.DashboardLayout}>
      {/* Permanent sidebar (desktop only) */}
      <div className={styles.LeftSection}>
        <SideBar />
      </div>

      {/* Mobile drawer sidebar */}
      <div
        className={`${styles.SidebarDrawer} ${sidebarOpen ? styles.open : ""}`}
      >
        <SideBar />
      </div>

      <div className={styles.RightSection}>
        <TopBar onHamburgerClick={() => setSidebarOpen((o) => !o)} />
        <main className="Main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default DashboardLayout;
